module.exports = __webpack_public_path__ + "img/Yes.0c90dbef.png";